import React, { createContext, useContext, useState, useCallback } from 'react';

const MapControlContext = createContext(); // Create a Context object

/**
 * Provides access to MapControl Context, handles changes in the map toggles
 * 
 * @param {React.ReactNode} props.children - children components to be wrapped by the provider
 * 
 * @returns {JSX.Element}
 * 
 * @category Context
 */
export const MapControlProvider = ({ children }) => {
    const [mapControl, setMapControl] = useState({
        'sc-toggle': true,
        'agm-toggle': true,
        'label-toggle': true,
        'sc-label-toggle': false
    });

    // This function should ideally take the event as an argument if called directly from an event handler
    const handleMapControlChange = useCallback((value) => {
        const { name, checked } = value; // Destructuring directly from event.target
        // console.log(name, checked); // Logging the name and checked status
        setMapControl(prev => ({
            ...prev,
            [name]: checked // Updating state based on checkbox name and its checked status
        }));
    }, []);

    return (
        <MapControlContext.Provider value={{ mapControl, handleMapControlChange }}>
            {children}
        </MapControlContext.Provider>
    );
};

/**
 * Custom hook to access the MapControl context
 * 
 * @returns {Object} The MapControl context including mapControl, handleMapControlChange.
 * 
 * @category Context
 */
export const useMapControl = () => useContext(MapControlContext); // Custom hook for accessing context
